module.exports = __webpack_public_path__ + "static/media/thao-le-hoang-1553111-unsplash.7b0afcd5.jpg";